import { useId } from "react";
import type { ReactNode } from "react";
import Modal from "./Modal";

export interface DialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  children?: ReactNode;
  footer?: ReactNode;
  size?: "sm" | "md" | "lg";
}

/** Diálogo padrão: cabeçalho, corpo e rodapé de ações. */
export default function Dialog({
  open,
  onClose,
  title,
  description,
  children,
  footer,
  size = "md",
}: DialogProps) {
  const titleId = useId();

  return (
    <Modal open={open} onClose={onClose} size={size} labelledBy={titleId}>
      <header className="mb-4">
        <h2 id={titleId} className="text-base font-semibold text-ink">
          {title}
        </h2>
        {description && <p className="mt-1 text-sm text-ink-muted">{description}</p>}
      </header>

      {children && <div className="space-y-4">{children}</div>}

      {footer && <footer className="mt-6 flex justify-end gap-2">{footer}</footer>}
    </Modal>
  );
}
